import React, { useEffect, useContext } from 'react';
import {
  HrFlexContainer,
  HrGrey,
  HrTitleContainer,
  HrTitleH4,
  HrTitleH6
} from '@components/styles/hr-styles';
import { useMutation } from '@tanstack/react-query';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { vacancyRequirementType } from '../../../constant/vacancy-requirement';
import { getCountries } from '../../../crud_vacancy/services/api-hiringroom';
import { getAreaEstudio, getStudyLevels, getStudyStatus } from '../../services/api';
import useStore from '../../store/useStore';
import { SectionEducation } from './education';
import { DisplaySettingsContext } from '../../store/display-settings';

export const ControllerEducation = observer(
  ({
    vacancyRequirement,
    register,
    formState,
    control,
    getValues,
    setValue,
    unregister,
    postulant,
    action
  }) => {
    const [t] = useTranslation();
    const {
      countries,
      studylevels,
      studyStatus,
      studyAreas,
      institutions,
      setDataStudy,
      setCountries
    } = useStore();

    const _getCountries = useMutation(getCountries, {
      onSuccess: (data) => setCountries(data.data.response)
    });
    const _getStudyLevels = useMutation(getStudyLevels, {
      onSuccess: (data) => {
        const { nivelEstudio = [] } = data.data.response;
        const _nivelEstudio = nivelEstudio.filter((level) => level.nombre !== 'Primario');
        setDataStudy(_nivelEstudio, 'studylevels');
      }
    });
    const _getStudyStatus = useMutation(getStudyStatus, {
      onSuccess: (data) => {
        const estadoEducacion = data.data.response.estadoEducacion?.filter(
          (state) => state.nombre !== 'Indistinto'
        );
        setDataStudy(estadoEducacion, 'studyStatus');
      }
    });
    const _getAreaEstudio = useMutation(getAreaEstudio, {
      onSuccess: (data) => setDataStudy(data.data.response.areaEducation, 'studyAreas')
    });

    useEffect(() => {
      if (studylevels.length === 0) _getStudyLevels.mutate();
      if (studyStatus.length === 0) _getStudyStatus.mutate();
      if (studyAreas.length === 0) _getAreaEstudio.mutate();
      if (countries.length === 0) _getCountries.mutate();
    }, []);

    const { darkMode, fontSizeSetting } = useContext(DisplaySettingsContext);

    return (
      <HrFlexContainer flexDirection='column' alignItems='flex-start'>
        {/* EDUCACION */}
        {vacancyRequirement.educ !== vacancyRequirementType.disabled && (
          <HrTitleContainer borderBottom={darkMode ? '1px solid #767676' : ''} flexWrap='wrap'>
            <HrTitleH4
              fontSizeSetting={fontSizeSetting}
              color={darkMode ? 'white' : ''}
              isRequired={vacancyRequirement.educ === 1}
            >
              {t('postulant.education.title')}
            </HrTitleH4>
            {vacancyRequirement.educ === 1 && (
              <HrTitleH6 fontSizeSetting={fontSizeSetting} color={darkMode ? '#DADADA' : HrGrey}>
                {t('postulant.education.obligatory')}
              </HrTitleH6>
            )}
          </HrTitleContainer>
        )}

        <SectionEducation
          postulant={postulant}
          vacancyRequirement={vacancyRequirement}
          institutions={institutions}
          studyAreas={studyAreas}
          countries={countries}
          studylevels={studylevels}
          studyStatus={studyStatus}
          register={register}
          control={control}
          formState={formState}
          setValue={setValue}
          getValues={getValues}
          unregister={unregister}
          action={action}
        />
      </HrFlexContainer>
    );
  }
);
